export default [
	{
		label: 'Text',
		name: 'text',
		widget: 'text'
	}
];
